/**
 * Forge Preview Components — card thumbnails
 * Extracted from ParagonLibraryPanel.tsx (TASK-009)
 */
/* eslint-disable react-refresh/only-export-components */
import type { ForgeTemplate } from './forge-types'

function StylistFlipPreview() {
  return (
    <div
      style={{
        background: 'linear-gradient(160deg, #1a1625, #0f0a1a)',
        padding: 20,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          padding: 3,
          borderRadius: 14,
          background: 'linear-gradient(135deg, #a78bfa, #f472b6)',
          boxShadow: '0 0 12px rgba(167,139,250,0.25), 0 0 25px rgba(244,114,182,0.15)',
          width: 160,
        }}
      >
        <div
          style={{
            borderRadius: 11,
            background: 'linear-gradient(160deg, #1a1625, #0f0a1a)',
            padding: '16px 12px',
            textAlign: 'center',
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              margin: '0 auto 8px',
              padding: 2,
              background: 'linear-gradient(135deg, #a78bfa, #f472b6)',
            }}
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, rgba(167,139,250,0.2), rgba(244,114,182,0.1))',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 16,
                fontWeight: 700,
                color: 'rgba(255,255,255,0.3)',
              }}
            >
              A
            </div>
          </div>
          <div style={{ fontSize: 11, fontWeight: 700, color: '#fafafa', marginBottom: 2 }}>
            Alex R.
          </div>
          <div
            style={{
              fontSize: 8,
              color: '#a78bfa',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              marginBottom: 8,
            }}
          >
            Colorist
          </div>
          <div
            style={{
              fontSize: 8,
              padding: '4px 10px',
              borderRadius: 4,
              background: '#a78bfa',
              color: '#fff',
              fontWeight: 600,
              display: 'inline-block',
            }}
          >
            Book →
          </div>
          <div style={{ fontSize: 7, color: 'rgba(255,255,255,0.2)', marginTop: 6 }}>
            ↻ flip for products
          </div>
        </div>
      </div>
    </div>
  )
}

function TestimonialCarouselPreview() {
  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #1a1020, #0d0a14)',
        padding: 20,
        textAlign: 'center',
      }}
    >
      <div style={{ display: 'flex', gap: 4, justifyContent: 'center', marginBottom: 8 }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <span key={`star-${star}`} style={{ color: '#f59e0b', fontSize: 12 }}>
            ★
          </span>
        ))}
      </div>
      <p
        style={{
          fontSize: 11,
          color: '#d4d4d8',
          fontStyle: 'italic',
          marginBottom: 8,
          lineHeight: 1.4,
        }}
      >
        &ldquo;Absolutely transformed my look. Can&apos;t recommend enough!&rdquo;
      </p>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
        <div
          style={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #f472b6, #a78bfa)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 9,
            fontWeight: 700,
            color: '#fff',
          }}
        >
          S
        </div>
        <span style={{ fontSize: 10, color: '#a1a1aa' }}>Sarah M.</span>
      </div>
      <div style={{ display: 'flex', gap: 4, justifyContent: 'center', marginTop: 10 }}>
        {[1, 2, 3].map((dot) => (
          <div
            key={`dot-${dot}`}
            style={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              background: dot === 1 ? '#f472b6' : 'rgba(255,255,255,0.15)',
            }}
          />
        ))}
      </div>
    </div>
  )
}

function BeforeAfterPreview() {
  return (
    <div style={{ background: '#0a0a0f', position: 'relative', height: 140, overflow: 'hidden' }}>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          left: 0,
          width: '50%',
          background: 'linear-gradient(135deg, #78350f, #92400e)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)', fontWeight: 600 }}>
          BEFORE
        </span>
      </div>
      <div
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: '50%',
          width: '50%',
          background: 'linear-gradient(135deg, #a78bfa, #f472b6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.7)', fontWeight: 600 }}>AFTER</span>
      </div>
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: 0,
          bottom: 0,
          width: 2,
          background: '#fff',
          transform: 'translateX(-50%)',
          zIndex: 2,
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
            width: 20,
            height: 20,
            borderRadius: '50%',
            background: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 8,
            color: '#000',
          }}
        >
          ⇔
        </div>
      </div>
    </div>
  )
}

function PricingTablePreview() {
  return (
    <div style={{ background: '#0f0f14', padding: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
        <div
          style={{
            background: 'rgba(255,255,255,0.06)',
            borderRadius: 6,
            padding: 2,
            display: 'flex',
            gap: 2,
          }}
        >
          <span
            style={{
              fontSize: 8,
              padding: '3px 8px',
              borderRadius: 4,
              background: '#60A5FA',
              color: '#000',
              fontWeight: 700,
            }}
          >
            Monthly
          </span>
          <span style={{ fontSize: 8, padding: '3px 8px', borderRadius: 4, color: '#71717a' }}>
            Per Visit
          </span>
        </div>
      </div>
      {[
        { n: 'Starter', p: '$29', a: false },
        { n: 'Pro ✦', p: '$79', a: true },
        { n: 'Elite', p: '$149', a: false },
      ].map((t) => (
        <div
          key={t.n}
          style={{
            background: t.a ? 'rgba(96,165,250,0.08)' : 'rgba(255,255,255,0.02)',
            border: `1px solid ${t.a ? '#60A5FA' : '#27272a'}`,
            borderRadius: 6,
            padding: '6px 10px',
            marginBottom: 4,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span style={{ fontSize: 10, fontWeight: 600, color: t.a ? '#60A5FA' : '#d4d4d8' }}>
            {t.n}
          </span>
          <span
            style={{
              fontSize: 12,
              fontWeight: 700,
              color: '#fafafa',
              fontFamily: "'JetBrains Mono', monospace",
            }}
          >
            {t.p}
          </span>
        </div>
      ))}
    </div>
  )
}

function BookingWidgetPreview() {
  const days = ['M', 'Tu', 'W', 'Th', 'F', 'Sa', 'Su']
  const avail = [false, true, true, false, true, true, false]
  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #042f2e, #064e3b)',
        padding: 16,
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: 10, fontWeight: 600, color: '#fafafa', marginBottom: 8 }}>
        February 2026
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 3 }}>
        {days.map((d) => (
          <div key={d} style={{ fontSize: 7, color: '#71717a', paddingBottom: 2 }}>
            {d}
          </div>
        ))}
        {Array.from({ length: 28 }, (_, i) => {
          const isAvail = avail[i % 7]
          const isSelected = i === 11
          return (
            <div
              key={`day-${i + 1}`}
              style={{
                width: 16,
                height: 16,
                borderRadius: 4,
                fontSize: 7,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto',
                background: isSelected
                  ? '#22c55e'
                  : isAvail
                    ? 'rgba(34,197,94,0.15)'
                    : 'rgba(255,255,255,0.03)',
                color: isSelected ? '#000' : isAvail ? '#22c55e' : '#3f3f46',
                fontWeight: isSelected ? 700 : 400,
              }}
            >
              {i + 1}
            </div>
          )
        })}
      </div>
    </div>
  )
}

function GalleryLightboxPreview() {
  const colors = [
    'linear-gradient(135deg, #a78bfa, #6366f1)',
    'linear-gradient(135deg, #f472b6, #ec4899)',
    'linear-gradient(135deg, #60A5FA, #3b82f6)',
    'linear-gradient(135deg, #f59e0b, #d97706)',
  ]
  return (
    <div style={{ background: '#0a0a0f', padding: 12 }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        {colors.map((bg) => (
          <div
            key={bg}
            style={{
              background: bg,
              borderRadius: 6,
              height: 54,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span style={{ fontSize: 14, opacity: 0.4 }}>🖼</span>
          </div>
        ))}
      </div>
      <div style={{ fontSize: 8, color: '#52525b', textAlign: 'center', marginTop: 6 }}>
        Click to expand
      </div>
    </div>
  )
}

function TeamRosterPreview() {
  const members = [
    { i: 'J', c: '#14b8a6' },
    { i: 'M', c: '#f59e0b' },
    { i: 'K', c: '#fb7185' },
  ]
  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #0f1a1a, #0a1414)',
        padding: 18,
        display: 'flex',
        justifyContent: 'center',
        gap: 8,
      }}
    >
      {members.map((m, idx) => (
        <div key={m.i} style={{ width: 52, textAlign: 'center' }}>
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 10,
              margin: '0 auto 4px',
              background: `linear-gradient(135deg, ${m.c}, ${m.c}88)`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 14,
              fontWeight: 700,
              color: '#fff',
              border: `2px solid ${m.c}44`,
            }}
          >
            {m.i}
          </div>
          <div style={{ fontSize: 7, color: '#d4d4d8', fontWeight: 600 }}>Stylist</div>
          <div
            style={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              background: idx < 2 ? '#22c55e' : '#ef4444',
              margin: '3px auto 0',
            }}
          />
        </div>
      ))}
    </div>
  )
}

function ServiceMenuPreview() {
  const items = [
    { n: 'Haircuts', p: '$45+', open: true },
    { n: 'Color', p: '$120+', open: false },
    { n: 'Treatments', p: '$65+', open: false },
  ]
  return (
    <div style={{ background: '#0f0f14', padding: 14 }}>
      {items.map((s) => (
        <div key={s.n} style={{ borderBottom: '1px solid #1e1e24', padding: '7px 0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 10, fontWeight: 600, color: s.open ? '#f59e0b' : '#a1a1aa' }}>
              {s.open ? '▾' : '▸'} {s.n}
            </span>
            <span
              style={{ fontSize: 9, color: '#71717a', fontFamily: "'JetBrains Mono', monospace" }}
            >
              {s.p}
            </span>
          </div>
          {s.open && (
            <div style={{ fontSize: 8, color: '#52525b', paddingLeft: 12, marginTop: 3 }}>
              Women's Cut · Men's Cut · Kids
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

function LoyaltyRewardsPreview() {
  return (
    <div
      style={{
        background: 'linear-gradient(160deg, #1a0f18, #0f0a14)',
        padding: 18,
        textAlign: 'center',
      }}
    >
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        style={{ margin: '0 auto 6px', display: 'block' }}
      >
        <circle cx="32" cy="32" r="28" stroke="#27272a" strokeWidth="4" fill="none" />
        <circle
          cx="32"
          cy="32"
          r="28"
          stroke="#fb7185"
          strokeWidth="4"
          fill="none"
          strokeDasharray="176"
          strokeDashoffset="58"
          strokeLinecap="round"
          transform="rotate(-90 32 32)"
        />
        <text x="32" y="35" textAnchor="middle" fill="#fb7185" fontSize="14" fontWeight="700">
          67%
        </text>
      </svg>
      <div
        style={{
          fontSize: 8,
          color: '#fb7185',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
        }}
      >
        Gold Tier
      </div>
      <div style={{ fontSize: 7, color: '#52525b', marginTop: 2 }}>3 visits to Platinum</div>
    </div>
  )
}

function SocialProofPreview() {
  const colors = ['#f97316', '#14b8a6', '#f472b6', '#60A5FA', '#f59e0b', '#a78bfa']
  return (
    <div style={{ background: '#0a0a0f', padding: 10 }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 3 }}>
        {colors.map((c, i) => (
          <div
            key={c}
            style={{
              background: `${c}18`,
              border: `1px solid ${c}30`,
              borderRadius: 4,
              height: 36,
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              padding: 3,
            }}
          >
            <span style={{ fontSize: 6, color: c }}>♥ {12 + i * 7}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

function HoursLocationPreview() {
  const days = [
    { d: 'Mon', h: '9–7' },
    { d: 'Tue', h: '9–7' },
    { d: 'Wed', h: '9–8', today: true },
    { d: 'Thu', h: '9–7' },
  ]
  return (
    <div style={{ background: 'linear-gradient(135deg, #0a1520, #0f1a2a)', padding: 14 }}>
      {days.map((d) => (
        <div
          key={d.d}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '3px 0',
            borderLeft: d.today ? '2px solid #38bdf8' : '2px solid transparent',
            paddingLeft: 6,
          }}
        >
          <span
            style={{
              fontSize: 9,
              color: d.today ? '#38bdf8' : '#71717a',
              fontWeight: d.today ? 700 : 400,
            }}
          >
            {d.d}
          </span>
          <span
            style={{
              fontSize: 9,
              color: d.today ? '#fafafa' : '#52525b',
              fontFamily: "'JetBrains Mono', monospace",
            }}
          >
            {d.h}
          </span>
        </div>
      ))}
      <div
        style={{
          marginTop: 6,
          fontSize: 8,
          color: '#38bdf8',
          display: 'flex',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: '#22c55e',
            display: 'inline-block',
          }}
        />{' '}
        Open Now
      </div>
    </div>
  )
}

function ProductShowcasePreview() {
  const products = [
    { n: 'Olaplex No.3', p: '$30', c: '#34d399' },
    { n: 'K18 Mask', p: '$75', c: '#60A5FA' },
  ]
  return (
    <div style={{ background: '#0a0f0f', padding: 14, display: 'flex', gap: 6 }}>
      {products.map((p) => (
        <div
          key={p.n}
          style={{
            flex: 1,
            background: `${p.c}08`,
            border: `1px solid ${p.c}25`,
            borderRadius: 8,
            padding: 8,
            textAlign: 'center',
          }}
        >
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: 6,
              background: `${p.c}20`,
              margin: '0 auto 4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 14,
            }}
          >
            🧴
          </div>
          <div style={{ fontSize: 8, fontWeight: 600, color: '#d4d4d8', marginBottom: 2 }}>
            {p.n}
          </div>
          <div
            style={{
              fontSize: 9,
              fontWeight: 700,
              color: p.c,
              fontFamily: "'JetBrains Mono', monospace",
            }}
          >
            {p.p}
          </div>
        </div>
      ))}
    </div>
  )
}

function AppointmentStepsPreview() {
  const steps = ['Check In', 'Consult', 'Service', 'Review']
  return (
    <div
      style={{
        background: '#0f0f18',
        padding: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0,
      }}
    >
      {steps.map((s, i) => (
        <div key={s} style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ textAlign: 'center' }}>
            <div
              style={{
                width: 18,
                height: 18,
                borderRadius: '50%',
                background: i <= 1 ? '#818cf8' : '#27272a',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 8,
                color: i <= 1 ? '#fff' : '#52525b',
                fontWeight: 700,
                margin: '0 auto 3px',
              }}
            >
              {i + 1}
            </div>
            <div style={{ fontSize: 6, color: i <= 1 ? '#818cf8' : '#3f3f46', fontWeight: 500 }}>
              {s}
            </div>
          </div>
          {i < steps.length - 1 && (
            <div
              style={{
                width: 14,
                height: 2,
                background: i < 1 ? '#818cf8' : '#27272a',
                margin: '0 2px',
                marginBottom: 12,
              }}
            />
          )}
        </div>
      ))}
    </div>
  )
}

function ContactFormPreview() {
  return (
    <div style={{ background: 'linear-gradient(160deg, #140f1a, #0f0a14)', padding: 14 }}>
      {['Your Name', 'Email Address'].map((p) => (
        <div
          key={p}
          style={{
            background: 'rgba(255,255,255,0.03)',
            border: '1px solid #27272a',
            borderRadius: 5,
            padding: '5px 8px',
            marginBottom: 4,
            fontSize: 8,
            color: '#3f3f46',
          }}
        >
          {p}
        </div>
      ))}
      <div
        style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid #27272a',
          borderRadius: 5,
          padding: '5px 8px',
          height: 24,
          marginBottom: 6,
          fontSize: 8,
          color: '#3f3f46',
        }}
      >
        Message...
      </div>
      <div
        style={{
          fontSize: 8,
          padding: '4px 0',
          borderRadius: 4,
          background: '#e879f9',
          color: '#000',
          fontWeight: 700,
          textAlign: 'center',
        }}
      >
        Send Inquiry
      </div>
    </div>
  )
}

function StatsCounterPreview() {
  const stats = [
    { n: '2.4K', l: 'Clients', c: '#a3e635' },
    { n: '12', l: 'Years', c: '#f59e0b' },
    { n: '98%', l: 'Rating', c: '#60A5FA' },
  ]
  return (
    <div
      style={{
        background: '#0a0f0a',
        padding: 14,
        display: 'flex',
        gap: 6,
        justifyContent: 'center',
      }}
    >
      {stats.map((s) => (
        <div key={s.l} style={{ textAlign: 'center', flex: 1 }}>
          <div
            style={{
              fontSize: 16,
              fontWeight: 800,
              color: s.c,
              fontFamily: "'JetBrains Mono', monospace",
            }}
          >
            {s.n}
          </div>
          <div
            style={{
              fontSize: 7,
              color: '#52525b',
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              marginTop: 2,
            }}
          >
            {s.l}
          </div>
        </div>
      ))}
    </div>
  )
}

function HeroBannerPreview() {
  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #0f1a2a, #0a0f1a, #140f1a)',
        padding: 20,
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: -10,
          right: -10,
          width: 50,
          height: 50,
          borderRadius: '50%',
          background: 'radial-gradient(circle, #22d3ee22, transparent)',
          filter: 'blur(10px)',
        }}
      />
      <div
        style={{
          fontSize: 14,
          fontWeight: 800,
          color: '#fafafa',
          lineHeight: 1.2,
          marginBottom: 4,
        }}
      >
        Your Style,
        <br />
        <span
          style={{
            background: 'linear-gradient(90deg, #22d3ee, #818cf8)',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: 'transparent',
          }}
        >
          Elevated
        </span>
      </div>
      <div style={{ fontSize: 7, color: '#52525b', marginBottom: 8 }}>Premium salon experience</div>
      <div
        style={{
          fontSize: 8,
          padding: '4px 12px',
          borderRadius: 4,
          background: '#22d3ee',
          color: '#000',
          fontWeight: 700,
          display: 'inline-block',
        }}
      >
        Book Now
      </div>
    </div>
  )
}

/* ── Preview map keyed by category ── */
export function getPreview(template: ForgeTemplate): React.ReactNode {
  const cat = template.category.toLowerCase()
  const cfg = template.config as Record<string, string>
  if (cat === 'stylist') return <StylistFlipPreview />
  if (cat === 'showcase' && cfg.type === 'gallery') return <GalleryLightboxPreview />
  if (cat === 'showcase') return <TestimonialCarouselPreview />
  if (cat === 'interactive' && cfg.type === 'pricing') return <PricingTablePreview />
  if (cat === 'interactive') return <BeforeAfterPreview />
  if (cat === 'booking') return <BookingWidgetPreview />
  if (cat === 'team') return <TeamRosterPreview />
  if (cat === 'services') return <ServiceMenuPreview />
  if (cat === 'loyalty') return <LoyaltyRewardsPreview />
  if (cat === 'social') return <SocialProofPreview />
  if (cat === 'info') return <HoursLocationPreview />
  if (cat === 'products') return <ProductShowcasePreview />
  if (cat === 'timeline') return <AppointmentStepsPreview />
  if (cat === 'contact') return <ContactFormPreview />
  if (cat === 'analytics') return <StatsCounterPreview />
  if (cat === 'hero') return <HeroBannerPreview />
  return null
}
